module.exports = __webpack_public_path__ + "static/media/accept.21f9a46f.svg";